import { render, staticRenderFns } from "./SushiDiaoxianItemZhixi.vue?vue&type=template&id=10dca11a&scoped=true&"
import script from "./SushiDiaoxianItemZhixi.vue?vue&type=script&lang=js&"
export * from "./SushiDiaoxianItemZhixi.vue?vue&type=script&lang=js&"
import style0 from "./SushiDiaoxianItemZhixi.vue?vue&type=style&index=0&id=10dca11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dca11a",
  null
  
)

export default component.exports